function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowCircleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 7.99996C1.33301 11.6733 4.32634 14.6666 7.99967 14.6666C11.673 14.6666 14.6663 11.6733 14.6663 7.99996C14.6663 4.32663 11.673 1.33329 7.99967 1.33329C4.32634 1.33329 1.33301 4.32663 1.33301 7.99996ZM9.99967 6.80663C10.193 6.61329 10.513 6.61329 10.7063 6.80663C10.8063 6.90663 10.853 7.03329 10.853 7.15996C10.853 7.28663 10.8063 7.41329 10.7063 7.51329L8.35301 9.86663C8.15967 10.06 7.83967 10.06 7.64634 9.86663L5.29301 7.51329C5.09967 7.31996 5.09967 6.99996 5.29301 6.80663C5.48634 6.61329 5.80634 6.61329 5.99967 6.80663L7.99967 8.80663L9.99967 6.80663Z",
    fill: "#FC1C52",
    style: {
      fill: "#FC1C52",
      fill: "color(display-p3 0.9874 0.1111 0.3214)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleLeft);
export default __webpack_public_path__ + "static/media/arrow-circle-left.9854f749c50a2bece85d6d0a30c49115.svg";
export { ForwardRef as ReactComponent };